import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BitmapText } from '@pixi/react';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import { DISCARD_ONE_TEXT } from '../../../../stringConstants';
import { DISCARD_CONTROLS_ARROW_COLOR_NUM, DISCARD_CONTROLS_ARROW_LINE_COLOR_NUM } from '../../../../styles/colors';
import { getBitmapTextDimensions } from '../../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../../utils/utils';
import { Arrow } from '../../pixiComponents/arrow';
const BITMAP_TEXT_STYLE = 'discard-one';
export const PixiDiscardControls = () => {
    const tableAreaDimensions = useAppSelector((state) => state.gameDimensions.tableAreaDimensions, shallowEqual);
    const gameControlsDimensionsH = useAppSelector((state) => state.gameDimensions.gameControlsDimensions?.h);
    const { h: textHeight } = useMemo(() => getBitmapTextDimensions(DISCARD_ONE_TEXT, BITMAP_TEXT_STYLE), []);
    if (!tableAreaDimensions || gameControlsDimensionsH === undefined) {
        return null;
    }
    const arrowHeadLengthToLineRatio = 0.1;
    const arrowX = tableAreaDimensions.w / 5;
    const arrowY = tableAreaDimensions.h;
    const arrowW = tableAreaDimensions.w * (4 / 5);
    const arrowH = gameControlsDimensionsH;
    const textX = Math.round(tableAreaDimensions.w / 5 + (arrowHeadLengthToLineRatio / 2) * arrowW);
    const textY = Math.round(tableAreaDimensions.h + gameControlsDimensionsH / 2 - textHeight / 2);
    return (_jsxs(_Fragment, { children: [_jsx(Arrow, { x: arrowX, y: arrowY, w: arrowW, h: arrowH, fillColor: DISCARD_CONTROLS_ARROW_COLOR_NUM, arrowHeadLengthToLineRatio: arrowHeadLengthToLineRatio, lineWidth: 2, lineColor: DISCARD_CONTROLS_ARROW_LINE_COLOR_NUM }), _jsx(BitmapText, { x: textX, y: textY, text: DISCARD_ONE_TEXT, "pixi-data": isTestEnvironment() ? { type: 'discard-text' } : null, style: { fontName: BITMAP_TEXT_STYLE } })] }));
};
